import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FilterQueryProps } from '../../../../global/filter/FilterQueryModal'
import { useAccountReadContext } from '../../../../utils/AccountContextContext'
import { useApiClient } from '../../../../utils/ApiClient'
import { ClientApiClient } from '../../../../utils/clientApi'
import { useFetchOne } from '../../../../utils/useFetch'
import { SummaryItem } from '../../RebatesSummary'

interface IBRebateTransactionsSummary {
  summaryItems: SummaryItem[]
  isLoading: boolean
}

export const useIBRebateTransactionsSummary = (
  search?: FilterQueryProps
): IBRebateTransactionsSummary => {
  const apiClient = useApiClient(ClientApiClient)
  const { account } = useAccountReadContext()
  const { t } = useTranslation()

  const callback = useCallback(async () => {
    if (!account?.clientIntroducingBroker?.id) {
      return null
    }

    const rebateTransactionsSummary = await apiClient.getIBRebateTransactionsSummary(
      account.clientIntroducingBroker.id,
      { search }
    )

    return rebateTransactionsSummary
  }, [account?.clientIntroducingBroker?.id, apiClient, search])

  const { data: summaryData, isLoading } = useFetchOne(callback)

  const summaryItems = useMemo<SummaryItem[]>(() => {
    return [
      {
        title: t('IB.RebatesPage.Paid'),
        value: summaryData?.paid || 0,
      },
      {
        title: t('IB.RebatesPage.Pending'),
        value: summaryData?.pending || 0,
      },
      {
        title: t('IB.RebatesPage.Declined'),
        value: summaryData?.declined || 0,
      },
    ]
  }, [summaryData, t])

  return { summaryItems, isLoading }
}
